import type { Reminder } from './types'
import type { SnowflakeId } from '@/types/snowflake'

export type ReminderEvent =
  | { kind: 'upserted'; reminder: Reminder }
  | { kind: 'removed'; id: SnowflakeId }
  | { kind: 'dismissed'; id: string }
  | { kind: 'refetch' }

const CHANNEL = 'nova-reminders'

function getChannel(): BroadcastChannel | null {
  if (typeof BroadcastChannel === 'undefined') return null
  try {
    return new BroadcastChannel(CHANNEL)
  } catch {
    return null
  }
}

export function publishReminderEvent(event: ReminderEvent): void {
  const ch = getChannel()
  if (!ch) return
  try {
    ch.postMessage(event)
  } finally {
    ch.close()
  }
}

/** Returns an unsubscribe function. No-op (returns a noop unsub) when unavailable. */
export function subscribeReminderEvents(handler: (e: ReminderEvent) => void): () => void {
  if (typeof BroadcastChannel === 'undefined') return () => {}
  let ch: BroadcastChannel | null = null
  try {
    ch = new BroadcastChannel(CHANNEL)
  } catch {
    return () => {}
  }
  const listener = (ev: MessageEvent) => handler(ev.data as ReminderEvent)
  ch.addEventListener('message', listener)
  return () => {
    ch?.removeEventListener('message', listener)
    ch?.close()
  }
}
